export default "__VITE_ASSET__C4mJCf7z__"